export function validId(idNumber)  {

    // console.log('called validId');
    // console.log('idNumber :>> ', idNumber);

    const Today = new Date();
  
    // assume everything is correct and if it later turns out not to be, just set this to false
    var correct = true;
  
    // get first 6 digits as a valid date
    var tempDate = new Date(idNumber.substring(0, 2), idNumber.substring(2, 4)-1, idNumber.substring(4, 6));
    var id_date = tempDate.getDate();
    var id_month = tempDate.getMonth();
  
    var id_year = tempDate.getFullYear();
    const thisYear = Today.getFullYear();
  
    if((thisYear - id_year)>=100){
      tempDate.setFullYear(tempDate.getFullYear()+100);
      id_year = tempDate.getFullYear()
    }
  
    // eslint-disable-next-line eqeqeq
    if (!((tempDate.getFullYear().toString().substring(2,4) == idNumber.substring(0, 2)) && (id_month == idNumber.substring(2, 4) - 1) && (id_date == idNumber.substring(4, 6)))) {
        console.log('Date failed');
        correct = false;
    }
  
    // apply Luhn formula for check-digits
    var tempTotal = 0;
    var checkSum = 0;
    var multiplier = 1;
    for (var i = 0; i < 13; ++i) {
        tempTotal = parseInt(idNumber.charAt(i)) * multiplier;
        if (tempTotal > 9) {
            tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
        }
        checkSum = checkSum + tempTotal;
        multiplier = (multiplier % 2 === 0) ? 1 : 2;
    }
    if ((checkSum % 10) !== 0) {
        correct = false;
    };
  
    // console.log('correct :>> ', correct);

    // if no error found, hide the error message
    if (correct) {
      return true;
    } else {
      return false;
    }
  
}

export function twoDigit(num) {
  const myNum = num.toString();
  if (myNum.length<2){
    return "0" + myNum;
  } else {
    return myNum;
  }
}